import { toast } from 'react-toastify';

import {
  fetchProvisionalReceipt,
  sendNewNfse,
  sendMultipleNfse,
  cancelNfse,
  fetchNfseConcept,
  fetchDownloadNfse,
  fetchProvisionalReceiptResume
} from './services';

import {
  setProvisionalReceipt,
  clearNfWithErrors,
  setRpsInfo,
  setIsNfInfo,
  handleLoading,
  setIsResumeLoading,
  setIsCancelLoading,
  setRpsResume
} from './actions';

export const loadProvisionalReceipt = ({
  userId,
  establishmentId,
  page,
  pageSize,
  qp = '',
  extraProps
}) => dispatch => {
  const { startDate, endDate } = extraProps;

  let url = `${userId}/establishment/${establishmentId}/nf`;

  if(qp) {
    url = `${url}?startDate=${startDate}&endDate=${endDate}&pg=${page}&limit=${pageSize}${qp}`;
  } else {
    url = `${url}?startDate=${startDate}&endDate=${endDate}&pg=${page}&limit=${pageSize}&typeDateTime=paymentDateTime&documentTypeId=0&orderBy=paymentDateTime&sort=desc`;
  }

  if(qp.includes('nfseStatus')) {
    url = `${url}&typeDateTime=paymentDateTime&documentTypeId=0&orderBy=paymentDateTime`;
  }

  dispatch(handleLoading(true));

  return fetchProvisionalReceipt(url)
    .then(({ data }) => dispatch(setProvisionalReceipt(data?.content, data?.total)))
    .finally(() => dispatch(handleLoading(false)));
}

export const resendNfse = (
  userId,
  establishmentId,
  transactionId,
  page,
  pageSize,
  qp,
  props,
  params,
  handleCloseError
) => dispatch => {
  const { nfse, nfce } = props;

  let url = '';

  if(+nfse == 1) {
    url = `${userId}/establishment/${establishmentId}/nf/nfse/${transactionId}/send`;
  }

  if(+nfce == 1) {
    url = `${userId}/establishment/${establishmentId}/nf/nfe/${transactionId}/nfce/send`;
  }

  if(+nfse == 0 && +nfce == 0) {
    url = `${userId}/establishment/${establishmentId}/nf/nfse/${transactionId}/send`;
  }

  dispatch(handleLoading(true));

  return sendNewNfse(url, params)
    .then(res => {
      if(+res.data.nfseStatus != 4) {
        toast.success('Nota enviada com sucesso! Aguarde confirmação.');
        dispatch(loadProvisionalReceipt({ userId, establishmentId, page, pageSize, qp, extraProps: props }));
        handleCloseError();
      }
    })
    .catch(error => {
      if(error?.response?.data?.data?.msg) {
        toast.error(error?.response?.data?.data?.msg);
      }
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const resendMultipleNfse = (userId, establishmentId, nfList) => dispatch => {
  dispatch(handleLoading(true));

  return sendMultipleNfse(userId, establishmentId, nfList)
    .then(() => {
      toast.success('Notas fiscais reenviadas com sucesso!');
      return Promise.resolve();
    })
    .catch(() => Promise.reject())
    .finally(() => {
      dispatch(clearNfWithErrors());
      dispatch(handleLoading(false));
    });
}

export const sendCancelNfse = (userId, establishmentId, uuid, params) => dispatch => {
  dispatch(setIsCancelLoading(true));

  const { page, pageSize, qp, nfse, nfce, extraProps, code, reason } = params;

  let url = '';

  if(+nfse == 1) {
    url = `${userId}/establishment/${establishmentId}/nf/nfse/${uuid}/cancel`;
  }

  if(+nfce == 1) {
    url = `${userId}/establishment/${establishmentId}/nf/nfe/${uuid}/nfce/cancel`;
  }

  if(+nfse == 0 && +nfce == 0) {
    url = `${userId}/establishment/${establishmentId}/nf/nfse/${uuid}/cancel`;
  }

  const payload = {
    code,
    ...(+code == 9 && { reason })
  }

  return cancelNfse(url, payload)
    .then(({ data }) => {
      toast.success(data);
      dispatch(loadProvisionalReceipt({ userId, establishmentId, page, pageSize, qp, extraProps }));
    })
    .finally(() => dispatch(setIsCancelLoading(false)));
}

export const loadNfseConcept = (userId, establishmentId, sourceId) => dispatch => {
  dispatch(setIsNfInfo(false));

  return fetchNfseConcept(userId, establishmentId, sourceId)
    .then(({ data }) => {
      dispatch(setIsNfInfo(true));
      dispatch(setRpsInfo(data));
    })
    .catch(() => dispatch(setIsNfInfo(false)));
}

export const loadDownloadNfse = (userId, establishmentId, uuid, params) => dispatch => {
  const { nfse, nfce } = params || {};

  let url = '';

  if(+nfse == 1) {
    url = `${userId}/establishment/${establishmentId}/nf/nfse/${uuid}/download/pdf`;
  }

  if(+nfce == 1) {
    url = `${userId}/establishment/${establishmentId}/nf/nfe/${uuid}/nfce/download/pdf`;
  }

  if(+nfse == 0 && +nfce == 0) {
    url = `${userId}/establishment/${establishmentId}/nf/nfse/${uuid}/download/pdf`;
  }

  return fetchDownloadNfse(url)
    .then(async data => {
      try {
        const nfJson = JSON.parse(atob(data));

        if(nfJson?.error?.message) {
          return toast.error(nfJson?.error?.message);
        }
      } catch(_) {}

      const base64Pdf = await fetch(`data:application/pdf;base64,${data}`);
      const blobPdf = await base64Pdf.blob();

      return window.open(
        URL.createObjectURL(
          new Blob([blobPdf], {
            type: 'application/pdf'
          })
        )
      );
    })
    .catch(() => toast.error('Houve um problema ao baixar a nota fiscal.'));
}

export const loadProvisionalReceiptResume = (userId, establishmentId, qp, extraProps) => dispatch => {
  dispatch(setIsResumeLoading(true));

  let formattedQp = !qp?.includes('documentTypeId') ? `&documentTypeId=0${qp}` : qp;

  return fetchProvisionalReceiptResume(userId, establishmentId, formattedQp, extraProps)
    .then(({ data }) => dispatch(setRpsResume(data[0])))
    .finally(() => dispatch(setIsResumeLoading(false)));
}